import type { AnyObjectSchema } from "yup";
import { lazy, mixed, object } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import "@lib/messageComposition/chatMessaging/yupHelper";
import sharedConstants from "@lib/shared_constants";

import type { RcsMessageExport } from "..";
import { getRcsMediaSchema } from "./rcsMediaSchema";
import { getRcsTextSchema } from "./rcsTextSchema";
import { getRcsRichCardSchema } from "./rich_card";

export const rcsSchemaByMessageType = {
  text: (t, _message, isTwilioProvider) => getRcsTextSchema(t, isTwilioProvider),
  media: (t, _message, isTwilioProvider) => getRcsMediaSchema(t, isTwilioProvider),
  rich_card: (t, message, isTwilioProvider) => getRcsRichCardSchema(t, message, isTwilioProvider),
} as Record<
  RcsMessageExport["type"],
  (t: I18nT<"rcs-composer">, message: any, isTwilioProvider?: boolean) => AnyObjectSchema
>;

export const getRcsSchema = (t: I18nT<"rcs-composer">, isTwilioProvider?: boolean) =>
  lazy((message: RcsMessageExport) =>
    message.type && rcsSchemaByMessageType[message.type as RcsMessageExport["type"]]
      ? rcsSchemaByMessageType[message.type as RcsMessageExport["type"]](t, message, isTwilioProvider)
      : object({
          type: mixed()
            .oneOf(Object.values(sharedConstants.RCS.MESSAGE_TYPES))
            .required(t("invalid-rcs-message-type", "Selecting an RCS message type is required")),
        })
  );
